"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subscribe = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _NewsletterDialog = require("./components/NewsletterDialog/NewsletterDialog");
var _components = require("./components/NewsletterDialog/components");
var _types = require("./components/NewsletterDialog/types");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Subscribe = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    newsletterSubsciptionConfiguration,
    isMobileOffice
  } = (0, _hooks.useFooter)();
  const {
    footer,
    popup
  } = newsletterSubsciptionConfiguration ?? {};
  const {
    onClose,
    onOpen,
    open
  } = (0, _presentationHooks.useDisclose)();
  const [origin, setOrigin] = (0, _react.useState)(_types.Origin.OnlinePopup);
  (0, _hooks.useSubscribePopup)({
    open,
    onOpen,
    footer,
    popup
  });
  const openDialog = (0, _react.useCallback)(() => {
    _jsCookie.default.set(_constants.newsletterPopupCookieKey, _constants.newsletterPopupCookieValue, {
      expires: popup?.displayFrequencyInDays ?? _constants.cookieExpireDays
    });
    setOrigin(_types.Origin.OnlineFooter);
    onOpen();
  }, [popup?.displayFrequencyInDays, onOpen]);
  if (!footer?.enabled) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
      "data-testid": getTestId(_constants2.SUBSCRIBE),
      role: "button",
      tabIndex: 0,
      isMobileOfficeFull: isMobileOffice,
      onClick: openDialog,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconRoot, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Send, {
          fontSize: "inherit"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "subtitle1",
        component: "p",
        align: "center",
        fontWeight: "bold",
        children: footer.title
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.NewsletterDialogContextProvider, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewsletterDialog.NewsletterDialog, {
        open: open,
        origin: origin,
        onClose: onClose
      })
    })]
  });
};
exports.Subscribe = Subscribe;
